<template>
  <div class="face-recognition">
    <div class="card">
      <h3>人脸识别校验</h3>
      <div class="des" v-if="step == 1">
        <p>
          根据人社部要求，参加考试考生需要进行人脸识别校验，采集的数据我们将进行严格保密。
        </p>
        <el-button type="primary" @click="step = 2">开始人脸识别</el-button>
      </div>
      <face-photo v-if="step == 2"></face-photo>
    </div>
  </div>
</template>

<script>
import FacePhoto from "@/components/FacePhoto";
export default {
  name: "FaceRecognition",
  components: {
    FacePhoto,
  },
  data() {
    return {
      step: 1,
    };
  },
};
</script>

<style lang="scss">
.face-recognition {
  background-color: #f5f7fa;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  .card {
    border-radius: 6px;
    width: 1200px;
    padding: 10px 60px;
    box-sizing: border-box;
    background-color: #fff;
    h3 {
      font-size: 22px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dcdfe6;
    }
    .des {
      font-size: 18px;
      text-align: center;
      line-height: 120px;
      .el-button {
        width: 150px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0;
        border: 0;
        margin-top: 160px;
        font-size: 16px;
      }
    }
  }
}
</style>
